import moment from 'moment';

import { Employee, PodConfig, PodRule, ProgramTaskBase } from '.';
import { Enum, ProgramTaskStatus } from '../enums';

export class ProgramTaskAction extends Enum {
  translationKey = 'programTaskAction';

  static asArray: ProgramTaskAction[] = [];

  static byKey: { [name: string]: ProgramTaskAction } = {};

  static readonly UPDATE_TASK_STATUS_ATTEMPTED = new ProgramTaskAction(
    'UPDATE_TASK_STATUS_ATTEMPTED',
  );

  static readonly CHANGE_ASSIGNEE = new ProgramTaskAction('CHANGE_ASSIGNEE');

  static readonly OVERRIDE_TASK_TYPE = new ProgramTaskAction(
    'OVERRIDE_TASK_TYPE',
  );

  static readonly FORCE_OVERRIDE = new ProgramTaskAction('FORCE_OVERRIDE');

  static asActionsArray(
    task: ProgramTaskBase,
    taskDefinition?: PodRule,
    pod?: PodConfig,
    actingUser?: Employee,
  ) {
    const actions = [] as ProgramTaskAction[];

    const isCurrentMonth = task?.taskDate?.isSame(moment(), 'month');

    const isClosedStatus =
      task.status && !ProgramTaskStatus.asArrayOpened.includes(task.status);
    const isInProgress = ProgramTaskStatus.IN_PROGRESS === task.status;

    const isAssignedToUser =
      task?.assignee && actingUser?.id === task.assignee.id;
    const isSameRolInPod = pod?.isEmployeeInPod(
      actingUser,
      taskDefinition?.roles,
    );

    if (!isCurrentMonth || actingUser?.isExternal) return actions;

    if (
      ((task.status === ProgramTaskStatus.COMPLETED &&
        actingUser?.isPODAdmin) ||
        !isClosedStatus) &&
      (isAssignedToUser ||
        isSameRolInPod ||
        actingUser?.canPerformProgramTaskAction(
          ProgramTaskAction.CHANGE_ASSIGNEE,
          task.status,
        ))
    ) {
      actions.push(ProgramTaskAction.CHANGE_ASSIGNEE);
    }

    if (isClosedStatus) return actions;

    if (
      !isInProgress &&
      (isAssignedToUser ||
        actingUser?.canPerformProgramTaskAction(
          ProgramTaskAction.UPDATE_TASK_STATUS_ATTEMPTED,
          task.status,
        ))
    ) {
      actions.push(ProgramTaskAction.UPDATE_TASK_STATUS_ATTEMPTED);
    }

    if (
      taskDefinition?.flexible &&
      actingUser?.canPerformProgramTaskAction(
        ProgramTaskAction.OVERRIDE_TASK_TYPE,
        task.status,
      )
    ) {
      actions.push(ProgramTaskAction.OVERRIDE_TASK_TYPE);
    }

    if (taskDefinition?.id !== PodRule.WELLNESS_CHECK_IN_ID) {
      actions.push(ProgramTaskAction.FORCE_OVERRIDE);
    }

    return actions;
  }

  constructor(public readonly value: string) {
    super();
    ProgramTaskAction.asArray.push(this);
    ProgramTaskAction.byKey[value] = this;
  }
}

export default ProgramTaskAction;
